module.exports = __webpack_public_path__ + "static/soc3-07099dff4dccbac04814720c23d20805.png";